import { useState } from "react";
import { Mail, ArrowRight } from "lucide-react";
import { Input } from "./ui/input";
import { Button } from "./ui/button";
import { toast } from "sonner";

const NewsletterSignup = ({ variant = "light" }) => {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = (e) => {
    e.preventDefault();
    if (!email || !/.+@.+\..+/.test(email)) {
      toast.error("Please enter a valid email.");
      return;
    }
    setSubmitting(true);
    setTimeout(() => {
      setSubmitting(false);
      setEmail("");
      toast.success("Thanks for subscribing. Welcome to the community.");
    }, 600);
  };

  if (variant === "dark") {
    return (
      <form onSubmit={onSubmit} className="flex flex-col sm:flex-row gap-2">
        <div className="relative flex-1">
          <Mail className="absolute left-3.5 top-1/2 -translate-y-1/2 w-4 h-4 text-white/60" />
          <Input
            type="email"
            placeholder="you@example.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="h-12 pl-10 bg-white/5 border-white/15 text-white placeholder:text-white/45 focus-visible:ring-[hsl(var(--rc-gold))] focus-visible:border-[hsl(var(--rc-gold))]"
          />
        </div>
        <Button
          type="submit"
          disabled={submitting}
          className="bg-[hsl(var(--rc-gold))] hover:bg-[hsl(var(--rc-gold))]/90 text-[hsl(var(--rc-deep))] rounded-md h-12 px-5 font-semibold"
        >
          {submitting ? "Joining…" : (
            <span className="flex items-center">
              Subscribe <ArrowRight className="w-4 h-4 ml-2" />
            </span>
          )}
        </Button>
      </form>
    );
  }

  return (
    <form onSubmit={onSubmit} className="flex flex-col sm:flex-row gap-2">
      <div className="relative flex-1">
        <Mail className="absolute left-3.5 top-1/2 -translate-y-1/2 w-4 h-4 text-[hsl(var(--muted-foreground))]" />
        <Input
          type="email"
          placeholder="Your email address"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="h-12 pl-10 bg-white border-[hsl(var(--border))] focus-visible:ring-[hsl(var(--rc-purple))] focus-visible:border-[hsl(var(--rc-purple))]"
        />
      </div>
      <Button
        type="submit"
        disabled={submitting}
        className="bg-[hsl(var(--rc-deep))] hover:bg-[hsl(var(--rc-purple))] text-white rounded-md h-12 px-5"
      >
        {submitting ? "Joining…" : "Subscribe"}
      </Button>
    </form>
  );
};

export default NewsletterSignup;
